import { render, staticRenderFns } from "./InputMTimeAllocation.vue?vue&type=template&id=448fd1b6&scoped=true"
import script from "./InputMTimeAllocation.vue?vue&type=script&lang=js"
export * from "./InputMTimeAllocation.vue?vue&type=script&lang=js"
import style0 from "./InputMTimeAllocation.vue?vue&type=style&index=0&id=448fd1b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448fd1b6",
  null
  
)

export default component.exports